import Media from '@/components/base/media'
import Motion from '@/components/base/motion'
import { projectHeroRevealAnimation } from '@/components/sections/animations/project-hero'
import Hero from '@/components/sections/hero'
import ProjectCredits from '@/components/sections/project-credits'

import { cn } from '@/lib/utils'
import { WPMedia, WPPageData } from '@/types'

type ProjectHeroProps = {
  pageProps: WPPageData & {
    acf?: {
      hero?: {
        title?: string
        location?: string
        media?: WPMedia
      }
      credits?: {
        role: string
        name: string
      }[]
    }
  }
}

const ProjectHero = ({ pageProps }: ProjectHeroProps) => {
  const { title, location, media } = pageProps.acf?.hero || {}
  const credits = pageProps.acf?.credits

  return (
    <Motion animation={projectHeroRevealAnimation}>
      {(motionRef) => (
        <div ref={motionRef}>
          <Hero type="project" title={title} text={location} />
          {(media?.poster?.url || media?.video?.url) && (
            <div className="relative aspect-video">
              <Media
                data-lightbox
                media={media}
                unlockLoaderOnReady
                priority
                data-motion-media
                className={cn('absolute left-0 top-0 h-full w-full')}
              />
            </div>
          )}
          {credits && credits.length > 0 ? (
            <ProjectCredits
              collection={credits}
              className="bg-background-light dark:bg-background-dark"
            />
          ) : null}
        </div>
      )}
    </Motion>
  )
}

export default ProjectHero
